import { render, staticRenderFns } from "./AddLedgerRecordModal.vue?vue&type=template&id=6b446c4b&"
import script from "./AddLedgerRecordModal.vue?vue&type=script&lang=ts&"
export * from "./AddLedgerRecordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports